/**
 * Helpers para RUT chileno.
 *   formatRut("123456789")   → "12.345.678-9"
 *   formatRut("12.345.678-9") → "12.345.678-9" (idempotente)
 *   formatRut("")             → ""
 *   isValidRut("12.345.678-5") → bool (algoritmo módulo 11)
 *   cleanRut("12.345.678-9")  → "123456789"
 */

export const cleanRut = rut => {
  if (!rut) return "";
  return String(rut).replace(/[^0-9kK]/g, "").toUpperCase();
};

export const formatRut = rut => {
  const clean = cleanRut(rut);
  if (!clean) return "";
  if (clean.length < 2) return clean;
  const dv = clean.slice(-1);
  let body = clean.slice(0, -1);
  // miles con punto desde la derecha
  const parts = [];
  while (body.length > 3) {
    parts.unshift(body.slice(-3));
    body = body.slice(0, -3);
  }
  if (body) parts.unshift(body);
  return `${parts.join(".")}-${dv}`;
};

export const isValidRut = rut => {
  const clean = cleanRut(rut);
  if (clean.length < 2) return false;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  let sum = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const mod = 11 - (sum % 11);
  const expected = mod === 11 ? "0" : mod === 10 ? "K" : String(mod);
  return expected === dv;
};
